import React from "react";
import Aside from "../../Components/aside";
import ExcludedFulltextComponent from "../../Components/ExcludedFulltextComponent";
import TopBar from "../../Components/topBar";
import { SnackbarProvider } from "notistack";
const ExcludedFulltext = () => {
  return (
    <SnackbarProvider>
      <div className="main-wrapper">
        <div className="content-wrapper">
          <ExcludedFulltextComponent />
        </div>
      </div>
    </SnackbarProvider>
  );
};

export default ExcludedFulltext;
